import { Component, OnInit } from '@angular/core';
import { RegistrationFormModel, ValidationModel, PhoneNumberValidationModel } from '../models/registration-form.model';
import { AuthService } from '../../../shared/services/auth.service';
import { SmatNasaService } from '../service/SmatNasa.service';
import Swal from 'sweetalert2';
import { AppCode } from '../../../app.code';
import { EmailValidationModel, PasswordValidationModel, UserNameValidationModel } from '../../../shared/models/common-validation.model';
import { ClientService } from '../../../shared/services/client.service';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.css']
})
export class RegistrationFormComponent implements OnInit {

  registrationFormModel: RegistrationFormModel = new RegistrationFormModel();
  phoneNumberValidationModel: PhoneNumberValidationModel = new PhoneNumberValidationModel()
  validationModel: ValidationModel = new ValidationModel();
  passwordValidationModel: PasswordValidationModel = new PasswordValidationModel();
  emailValidationModel: EmailValidationModel = new EmailValidationModel();
  userNameValidationModel: UserNameValidationModel = new UserNameValidationModel();
  loading: boolean = false;
  next1Click: boolean = false;
  isValidForm: boolean = false;
  model: any = {};
  client: any = {};

  constructor(private clientService: ClientService, private authService: AuthService, private appCode: AppCode, private SmatNasa: SmatNasaService) {
    this.client = this.clientService.getClient();
    this.client.clientId = 176;
    this.model.registrationType = 'ByIndividual'
  }

  ngOnInit() {
  }
  // onSubmit Registration form
  async onSubmit() {
    this.loading = false;
    var result = await this.validateFormData();
    if (result != null && result != undefined) {
      if (result == true) {
        if (this.registrationFormModel.ninNumber == null)
          this.registrationFormModel.ninNumber = 0;
        if (this.registrationFormModel.rcNumber == null)
          this.registrationFormModel.rcNumber = 0;
        await this.SmatNasa.RegistrationFormAPI(this.registrationFormModel).toPromise().then(async (data: any) => {
          var result = data;
          var userData: any = { userName: this.registrationFormModel.emailAddress, email: this.registrationFormModel.userName, password: this.registrationFormModel.password, firstName: this.registrationFormModel.FirstName, lastName: this.registrationFormModel.LastName };
          var userId = await this.appCode.createUser(userData, ["NUDBApplicant"], false);
          if (userId != null && userId != undefined) {
            this.onclear();
            console.log(result);
            Swal.fire({
              text: ("Registration Completed Successfully."),
              confirmButtonText: 'Ok',
              confirmButtonColor: '#3085d6',
              allowOutsideClick: false
            }).then((result) => {
              this.loading = false;
            });
          }

        }).catch(err => {
          console.log(err);
          var resData = JSON.stringify(err);
          var newStr = jQuery.parseJSON(resData);
          var newStr1 = JSON.stringify(newStr.error);
          var newStr12 = jQuery.parseJSON(newStr1);
          this.loading = false;
          Swal.fire({
            text: newStr12.text,
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6',
            allowOutsideClick: false
          });
        });
        //this.onclear();

      }
      else {
        this.loading = false;
      }
    }
    else {
      this.loading = false;
    }
  }

  // Email Validation
  // Email Validation using Pattern
  async onChangeEmail(newValue) {
    this.emailValidationModel = await this.appCode.onEmailValidation(newValue, true);
  }


  async onChangePhone(newValue) {
    this.phoneNumberValidationModel = await this.onPhoneValidation(newValue, true);
  }


  async validateFormData() {
    //debugger
    this.validationModel = this.validateConfirmPassword(this.registrationFormModel.confirmpassword);
    this.validationModel.isFirstNameValid = this.registrationFormModel.FirstName == "" ? false : true;
    this.validationModel.isLastNameValid = this.registrationFormModel.LastName == "" ? false : true;
    this.validationModel.isphoneNumberValid = this.registrationFormModel.phoneNumber == "" ? false : true;
    this.validationModel.isninNumberValid = (this.model.registrationType == 'ByIndividual' && this.registrationFormModel.ninNumber == null) ? false : true;
    this.validationModel.iscompanyTypeValid = (this.model.registrationType == 'ByCompany' && this.registrationFormModel.companyType == "") ? false : true;
    this.validationModel.isrcNumberValid = (this.model.registrationType == 'ByCompany' && this.registrationFormModel.rcNumber == null) ? false : true;
    this.validationModel.isuserNameValid = this.registrationFormModel.userName == "" ? false : true;
    this.validationModel.isemailAddressValid = this.registrationFormModel.emailAddress == "" ? false : true;
    this.validationModel.ispasswordValid = this.registrationFormModel.password == "" ? false : true;
    this.emailValidationModel = await this.appCode.onEmailValidation(this.registrationFormModel.emailAddress, true);
    this.phoneNumberValidationModel = await this.onPhoneValidation(this.registrationFormModel.phoneNumber, true);

    this.passwordValidationModel = this.appCode.onPasswordValidation(this.registrationFormModel.password, true);
    this.userNameValidationModel = await this.appCode.checkUserNameExists(this.registrationFormModel.userName, this.registrationFormModel.userName);
   

    if (!this.validationModel.isFirstNameValid || !this.validationModel.isLastNameValid || !this.validationModel.isphoneNumberValid
     // || !this.validationModel.isninNumberValid  || !this.validationModel.isrcNumberValid
      || !this.validationModel.iscompanyTypeValid 
      || !this.validationModel.isuserNameValid || !this.validationModel.isemailAddressValid || !this.validationModel.ispasswordValid
      || !this.passwordValidationModel.isPasswordValid || !this.userNameValidationModel.isValid
      || !this.emailValidationModel.isEmailIdValid || !this.phoneNumberValidationModel.isPhoneValid || !this.validationModel.isconfirmpasswordValid
    ) {
      return this.isValidForm = false;
    }
    else {
      return this.isValidForm = true;
    }
  }

  onclear() {
    this.registrationFormModel.FirstName = "";
    this.registrationFormModel.LastName = "";
    this.registrationFormModel.address = "";
    this.registrationFormModel.phoneNumber = "";
    this.registrationFormModel.emailAddress = "";
    this.registrationFormModel.ninNumber = null;
    this.registrationFormModel.companyType = "";
    this.registrationFormModel.rcNumber = null;
    this.registrationFormModel.userName = "";
    this.registrationFormModel.password = "";
    this.registrationFormModel.confirmpassword = "";

    this.model.rcNumber = "";
    this.model.companyName = "";
    this.model.companyType = "";
    this.model.state = "";
    this.validationModel = new ValidationModel();
    this.emailValidationModel = new EmailValidationModel();
    this.passwordValidationModel = new PasswordValidationModel();
    this.userNameValidationModel = new UserNameValidationModel();
  }

  onChangeRegistrationType() {
    this.model.rcNumber = "";
    this.model.companyName = "";
    this.model.companyType = "";
    this.model.state = "";
    this.model.errorMessage = "";
    this.model.firstname = "";
    this.model.lastname = "";
    this.registrationFormModel.ninNumber = null;
    this.registrationFormModel.rcNumber = null;
    if (this.model.registrationType == 'ByIndividual') {
      this.registrationFormModel.companyType = "";
      this.registrationFormModel.rcNumber = null;
    }
    else if (this.model.registrationType == 'ByCompany') {
      this.registrationFormModel.ninNumber = null;
    }
  }

  async onComapny() {
    this.loading = true;
    this.validationModel.iscompanyTypeValid = (this.model.registrationType == 'ByCompany' && this.registrationFormModel.companyType == "") ? false : true;
    this.validationModel.isrcNumberValid = (this.model.registrationType == 'ByCompany' && this.registrationFormModel.rcNumber == null) ? false : true;
    this.registrationFormModel.ninNumber = 0;
    if (this.validationModel.iscompanyTypeValid && this.validationModel.isrcNumberValid) {
      await this.SmatNasa.ComapnyVerifyAPI(this.registrationFormModel).toPromise().then(async (data: any) => {
        this.loading = false;
        var result = data;
        this.model.rcNumber = data.rcNumber;
        this.model.companyName = data.companyName;
        this.model.companyType = data.companyType;
        this.model.state = data.state;
        this.model.errorMessage = data.errorMessage;
      });
      return true;
    }
    else {
      this.loading = false;
      return false;
    }
  }
  async onNINSubmit() {
    this.loading = true;
    this.validationModel.isFirstNameValid = this.registrationFormModel.FirstName == "" ? false : true;
    this.validationModel.isLastNameValid = this.registrationFormModel.LastName == "" ? false : true;
    this.validationModel.isninNumberValid = (this.model.registrationType == 'ByIndividual' && this.registrationFormModel.ninNumber == null) ? false : true;
    if (this.validationModel.isninNumberValid && this.validationModel.isFirstNameValid && this.validationModel.isLastNameValid) {
      this.registrationFormModel.rcNumber = 0;
      await this.SmatNasa.NINVerifyAPI(this.registrationFormModel).toPromise().then(async (data: any) => {
        this.model.firstname = data.firstname;
        this.model.lastname = data.lastname;
        this.model.errorMessage = data.errorMessage;
      });
      this.loading = false;
      return true;
    }
    else {
      this.loading = false;
      return false;
    }
  }
  // Password Pattern
  async validatePassword(event) {
    this.passwordValidationModel = await this.appCode.onPasswordValidation(event, true);
    if (this.registrationFormModel.confirmpassword != "") {
      this.validateConfirmPassword(this.registrationFormModel.confirmpassword)
    }
  }

  // Password Pattern & Validation Process
  validateConfirmPassword(password: string) {
    var isRequired = true;
    if (password == "" && isRequired) {
      this.validationModel.isconfirmpasswordValid = false;
      this.validationModel.confirmpasswordValidationMessage = "Confirm Password is required";
    }
    else if (this.registrationFormModel.password != password) {
      this.validationModel.isconfirmpasswordValid = false;
      this.validationModel.confirmpasswordValidationMessage = "Password and Confirm Password must be match";
    }
    else if (this.registrationFormModel.password == password) {
      this.validationModel.isconfirmpasswordValid = true;
      this.validationModel.confirmpasswordValidationMessage = "";
    }
    else {
      this.validationModel.isconfirmpasswordValid = false;
      this.validationModel.confirmpasswordValidationMessage = "Password and Confirm Password must be match";
    }

    return this.validationModel;
  }

  // phone number Pattern & Validation Process
  onPhoneValidation(newValue: string, isRequired: boolean) {
    const validPhoneRegEx = /^(([0]\d{10}$)|(^[\+]?[234]\d{12}))$/;
    this.phoneNumberValidationModel.isPhoneRequired = isRequired;
    if (isRequired == true && newValue == "") {
      this.phoneNumberValidationModel.isPhoneValid = false;
      this.phoneNumberValidationModel.validationMessage = "Phone No. is required.";
      return this.phoneNumberValidationModel;
    }
    else if (isRequired == false && newValue == "") {
      this.phoneNumberValidationModel.isPhoneValid = true;
      this.phoneNumberValidationModel.validationMessage = "";
      return this.phoneNumberValidationModel;
    }
    else if (validPhoneRegEx.test(newValue)) {
      this.phoneNumberValidationModel.isPhoneValid = true;
      this.phoneNumberValidationModel.validationMessage = "";
      return this.phoneNumberValidationModel;
    }
    else {
      this.phoneNumberValidationModel.isPhoneValid = false;
      this.phoneNumberValidationModel.validationMessage = "Invalid Phone No.";
      return this.phoneNumberValidationModel;
    }
  }

}
